import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { initReactI18next } from 'react-i18next'

// import { version } from '../../../package.json';
// Component
import resources from './resources'

const options = {
  order: ['cookie', 'navigator', 'localStorage', 'querystring', 'htmlTag'],
  lookupCookie: 'language',
}
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: options,

    // // have a common namespace used around the full app
    // ns: ['translations'],
    // defaultNS: 'translations',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      wait: true,
    },
  })

export default i18n
